import { FieldError } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useEffect } from "react"
import { hasValue } from "lib/@components/extended-select/plugins/required-field-error/has-value"

export const FIELD_ERROR_NO_UNIQUE = "noUniqueOptions"
export const FIELD_ERROR_NO_UNIQUE_TAG = "noUniqueTag"

export function UniqueFieldError() {
    const {
        item: { unique },
        noOptions,
        label,
        selectId,
        mapping,
    } = useBoundContext()

    useEffect(() => {
        const errorType = selectId === "tag" ? FIELD_ERROR_NO_UNIQUE_TAG : FIELD_ERROR_NO_UNIQUE
        const eventPayload = { id: selectId, field: label, errorType }

        if (unique && noOptions && !hasValue(mapping)) {
            FieldError(selectId)(errorType).raise({
                ...eventPayload,
                error: true,
            })
        }
        return () =>
            FieldError(selectId)(errorType).raise({
                ...eventPayload,
                error: false,
            })
    }, [selectId, label, unique, noOptions, mapping])
}
